import type { VariantType } from "@shared/graphql.types";

export function showCandleSafety(variant: VariantType): boolean {
  const { categoryName, product } = variant;

  return (
    variant.candleSafety ??
    (categoryName === "Candles" ||
      !!product?.categories?.find((category) => category?.name === "Candles"))
  );
}
